
import ChemicalIsotope from '@/tasks/components/displayers/ChemicalIsotope.vue';

export default ChemicalIsotope;
